import React from 'react';
import { Warning, CheckCircle, Info, TrendDown } from '@phosphor-icons/react';
import Typhography from '../../../shared/Typhography/Typhography';
import styles from './InsightsPanel.module.scss';
import type { ITrainingInsight } from '../../../models/trainingStatistics';

/**
 * Sezione 7 — Insights e alert bilanciamento rule-based.
 * Spec: LEOPART_ProgrammazioneCampo_Spec_v1.1.1.md righe 2900-2922.
 */
interface InsightsPanelProps {
  insights: ITrainingInsight[];
}

const SEVERITY_CONFIG = {
  info: {
    Icon: Info,
    color: '#1a8fb0',
    bg: '#e8f6fb',
    border: '#b3def0',
  },
  warning: {
    Icon: Warning,
    color: '#f59e0b',
    bg: '#fffbee',
    border: '#ffd15a',
  },
  critical: {
    Icon: TrendDown,
    color: '#dc2626',
    bg: '#fff5f5',
    border: '#fca5a5',
  },
};

const InsightsPanel: React.FC<InsightsPanelProps> = ({ insights }) => {
  if (!insights || insights.length === 0) {
    return (
      <div className={styles.noInsights}>
        <CheckCircle size={20} weight="fill" style={{ color: '#10b981' }} />
        <Typhography size="regular-14" className={styles.noInsightsText}>
          Nessuna anomalia rilevata nel periodo selezionato.
        </Typhography>
      </div>
    );
  }

  return (
    <div className={styles.list}>
      {insights.map((insight, i) => {
        const cfg = SEVERITY_CONFIG[insight.severity] ?? SEVERITY_CONFIG.info;
        const { Icon } = cfg;
        return (
          <div
            key={i}
            className={styles.card}
            style={{ background: cfg.bg, borderColor: cfg.border }}
          >
            <div className={styles.cardHeader}>
              <Icon size={18} weight="fill" style={{ color: cfg.color, flexShrink: 0 }} />
              <Typhography size="bold-14" className={styles.message} style={{ color: cfg.color }}>
                {insight.message}
              </Typhography>
            </div>
            {insight.suggestion && (
              <Typhography size="regular-12" className={styles.suggestion}>
                {insight.suggestion}
              </Typhography>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default InsightsPanel;
